<template>
  <header class="header">
    <section class="header-content">
      <div class="header-content__left">
        <img src="../../assets/logo-header.png" alt="" class="logo" @click="handleIndex" />
        <div class="text">会员服务</div>
      </div>
      <div class="header-content__right">
        <div class="login" v-if="!isLogin">
          <div @click="handleLogin" class="btn">登录</div>
          <div @click="handleRegister" class="btn">注册</div>
        </div>

        <div v-else class="user-info">
          <img :src="avatar(userInfo)" class="avatar">
          <div class="account">{{ userInfo.account }}</div>
          <div class="account" @click="modifyPassword()">修改密码</div>
          <div class="login-out" @click="handleLoginOut">
            <img :src="loginOutSvg" alt="" class="icon">
            注销
          </div>
        </div>
      </div>
    </section>
    <nav-bar></nav-bar>
  </header>
</template>

<script>
import { getUser, getToken, removeToken, removeUser } from "@/utils/auth.js";

import navBar from "./navBar.vue";
import defaultAvatar from "@/assets/defaultAvatar.svg";
import loginOutSvg from "@/assets/login-out.svg";

export default {
  components: {
    navBar,
  },
  data() {
    return {
      isLogin: false,
      defaultAvatar,
      loginOutSvg,
      userInfo: getUser(),
    };
  },
  created() {

    this.refresh();

    this.$loginBox.addEventListener(this.refresh);

  },

  methods: {

    async modifyPassword(){
      const value = prompt("请输入新密码")
      if(value){
        const res = await this.$fetch.post('/api/user/updatePassword',{
          id:this.userInfo.id,
          password:value,
        });
        if(res.code===0){
          alert("修改成功")
          this.handleLoginOut()
        }
      }
    },
    /**
     * 刷新用户登录状态和用户信息
     * 该方法首先检查本地存储中是否存在 token 来确定用户是否已登录
     * 然后获取用户信息，并在用户已登录且信息存在的情况下，向服务器发送请求以检查用户状态
     */
    refresh() {
      // 通过 getToken() 函数获取 token，并根据是否存在 token 来设置 isLogin 变量
      this.isLogin =!!getToken();
      // 调用 getUser() 函数获取用户信息，并将其存储在 userInfo 变量中
      this.userInfo = getUser();

      // 如果用户已登录且用户信息存在，则向服务器发送 POST 请求以检查用户状态
      if (this.isLogin && this.userInfo) {
        this.$fetch.post('/api/user/check-status');
      }
    },

    // 跳转到主页
    handleIndex() {
      if (this.$router.currentRoute.name !== 'index') {
        this.$router.push({
          name: 'index',
        });
      }

    },

    avatar(userInfo) {
      return userInfo.avatar || this.defaultAvatar;
    },



    handleLogin() {
      this.$loginBox.show('login');
    },

    handleRegister() {
      this.$loginBox.show('register');
    },

    handleLoginOut() {
      removeToken();
      removeUser();
      window.location.reload();
    }



  },
};
</script>

<style lang="less" scoped>
.header {
  height: 188px;
  box-sizing: border-box;
  background: #ffffff;
  width: 100%;
  z-index: 1000;
  top: 0;

  .header-content {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .header-content__left {
    display: flex;
    align-items: center;
    padding-top: 31px;
    padding-bottom: 20px;
    cursor: pointer;

    .logo {
      margin-right: 39px;
      height: 77px;
    }

    .text {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 22px;
      color: #3560ab;
      font-style: normal;
      display: flex;
      align-items: center;
      height: 100%;
    }
  }

  .header-content__right {
    display: flex;
    width: 300px;
    flex-direction: column;
    margin-top: 31px;
    height: 77px;
    justify-content: center;
    align-items: center;


    .user-info {
      height: 24px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      cursor: pointer;
      align-items: center;

      .account {
        font-size: 14px;
        color: #3560ab;
        margin-right: 8px;
      }

      .avatar {
        width: 24px;
        height: 24px;
        margin-right: 8px;
        border-radius: 50%;

      }

      .login-out {
        margin-left: 8px;
        display: flex;
        align-items: center;
        color: #3560ab;
        height: 100%;
        font-size: 14px;
        font-weight: bold;
        line-height: 100%;

        .icon {
          margin-right: 8px;
          width: 24px;
          height: 24px;
          border-radius: 50%;
        }


      }

    }

    .login {
      display: flex;
      flex-direction: row;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #3560ab;
      line-height: 22px;
      font-style: normal;
      text-transform: none;
      height: 100%;
      align-items: center;

      .btn {
        height: 16px;
        line-height: 16px;
        padding-left: 16px;
        padding-right: 16px;
        cursor: pointer;
      }

      .btn+.btn {
        border-left: 1px solid #3560ab;
      }
    }
  }
}
</style>
